import React from "react";
import { Link } from "react-router-dom";
import gsafe from "../../assets/images/gsafe.png";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <img
              src={require("../../assets/images/freemarket-todabranco.png")}
              alt="Free Market Seguros"
              className="max-h-[100px] max-w-full mb-1"
            />
            <p className="text-gray-400 mb-6">
              Somos uma das maiores corretoras de seguros do interior de Minas
              Gerais, com foco em excelência e atendimento personalizado.
            </p>
            <div className="flex space-x-4 mb-4">
              <a
                href="https://www.facebook.com/freemarketcorretoradesguros"
                className="text-gray-400 hover:text-white"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/freemarketseguros/"
                className="text-gray-400 hover:text-white"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/freemarketseguros"
                className="text-gray-400 hover:text-white"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://wa.me/553436710349"
                className="text-gray-400 hover:text-white"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Nossos Serviços</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/auto" className="text-gray-400 hover:text-white">
                  Seguro Auto
                </Link>
              </li>
              <li>
                <Link to="/saude" className="text-gray-400 hover:text-white">
                  Planos de Saúde
                </Link>
              </li>
              <li>
                <Link to="/agricola" className="text-gray-400 hover:text-white">
                  Seguro Agrícola
                </Link>
              </li>
              <li>
                <Link
                  to="/previdencia"
                  className="text-gray-400 hover:text-white"
                >
                  Previdência Privada
                </Link>
              </li>
              <li>
                <Link to="/vida" className="text-gray-400 hover:text-white">
                  Seguro de Vida
                </Link>
              </li>
              <li>
                <Link
                  to="/consorcio"
                  className="text-gray-400 hover:text-white"
                >
                  Consórcio
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/sobre" className="text-gray-400 hover:text-white">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-400 hover:text-white">
                  Contato
                </Link>
              </li>
              <li>
                <Link
                  to="/simulacao"
                  className="text-gray-400 hover:text-white"
                >
                  Simulação
                </Link>
              </li>
              <li>
                <Link
                  to="/politica-privacidade"
                  className="text-gray-400 hover:text-white"
                >
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="fas fa-map-marker-alt text-orange-500 mt-1 mr-3"></i>
                <span className="text-gray-400">
                  Rua Gameleiras, 141, 2º e 3º Andar
                  <br />
                  São Gotardo - MG, 38800-000
                </span>
              </li>
              <li className="flex items-center">
                <i className="fas fa-phone-alt text-orange-500 mr-3"></i>
                <span className="text-gray-400">(34) 3671-0353</span>
              </li>
              <li className="flex items-center">
                <i className="fas fa-envelope text-orange-500 mr-3"></i>
                <span className="text-gray-400">
                  contato@freemarketseguros.com.br
                </span>
              </li>
              <li className="flex items-center">
                <i className="fab fa-whatsapp text-orange-500 mr-3"></i>
                <span className="text-gray-400">(34) 3671-0349</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 text-center text-gray-500 space-y-4">
          {/* Container para selos, alinhado horizontalmente e centralizado */}
          <div className="flex justify-center items-center gap-6 mb-4">
            <a
              href="https://transparencyreport.google.com/safe-browsing/search?url=freemarketseguros.com.br"
              target="_blank"
              rel="noopener noreferrer"
              title="Verificação Google Safe Browsing"
            >
              <img
                src={gsafe}
                alt="Selo Google Safe Browsing"
                style={{ height: "100px", width: "auto" }}
              />
            </a>

            <a
              href="https://letsencrypt.org/"
              target="_blank"
              rel="noopener noreferrer"
              title="Site protegido por SSL Let's Encrypt"
            >
              <img
                src="https://letsencrypt.org/images/letsencrypt-logo-horizontal.svg"
                alt="SSL Let's Encrypt"
                style={{ height: "35px", width: "auto" }}
              />
            </a>
          </div>

          {/* Textos centralizados e com espaçamento entre eles */}
          <p>
            © {new Date().getFullYear()} Free Market Seguros. Todos os direitos
            reservados.
          </p>
          <p>CNPJ: 05.872.081/0001-33</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
